import React from "react";

interface VideosRecordedGraphDataProps {}

export const VideosRecordedGraphData: React.FC<VideosRecordedGraphDataProps> = () => {
  return <div></div>;
};
